// extracted by mini-css-extract-plugin
export default {"root":"label-field_root__i-rIf","label":"label-field_label__q7HW2","value":"label-field_value__NPoIt"};